'use strict';
function numeric(value) { return value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value)) ? Number(value) : null; }
function weatherAdvice(day) {
  if (!day) return [];
  const low = numeric(day.tempMin), high = numeric(day.tempMax), uv = numeric(day.uvIndex), precip = numeric(day.precip);
  const code = numeric(day.iconDay), condition = String(day.textDay || '') + String(day.textNight || '');
  const result = [];
  let clothing = '温度数据不足，出发前关注体感并备一件可增减的外套。';
  if (high !== null && low !== null) {
    clothing = high >= 28 ? '白天偏热，穿轻薄透气衣物。' : high >= 20 ? '长袖或薄外套，方便随温度增减。' : high >= 12 ? '建议外套搭配长裤，早晚注意保暖。' : '天气偏冷，建议保暖外套并按体感加衣。';
    if (high - low >= 8 || (high >= 28 && low < 21)) clothing += '早晚温差明显，随身备一件外套。';
  }
  result.push({ kind: 'clothing', title: '怎么穿', text: clothing });
  const rain = /雨|雪|雷/.test(condition) || (code !== null && code >= 300 && code < 500) || (precip !== null && precip > 0);
  result.push({ kind: 'umbrella', title: '要带伞吗', text: rain ? '预报有降水，建议带雨具，并备一个室内去处。' : condition || precip !== null ? '预报未提示明显降水，可备便携伞，临近出发再确认。' : '降水信息暂缺，先备便携伞，出发前再次查询。' });
  result.push({ kind: 'sun', title: '防晒提醒', text: uv === null ? '紫外线指数暂缺；长时间户外活动可备帽子与遮阳用品。' : uv >= 8 ? '紫外线指数 ' + uv + '，尽量避开正午长时间暴晒，做好遮阳和防晒。' : uv >= 3 ? '紫外线指数 ' + uv + '，户外活动建议遮阳、防晒，午间多在阴凉处休息。' : '紫外线指数 ' + uv + '，强度较低；长时间户外活动仍可按需遮阳。' });
  return result;
}
module.exports = { weatherAdvice, numeric };
